import { popUp } from "../../features/popUp/PopUp";

export const getPlayCanvasStringValue = (params: string) => {
  if (params) {
    const parsed = JSON.parse(params);
    return parsed["node-scena"];
  } else {
    popUp({ type: "warning", message: "Playcanvas params doesn't exist" });
  }
};
